"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("../../utils/styled-is"));
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close16"));
var _Download = _interopRequireDefault(require("@honeybook/icons/dist/icons/Download16"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBFileAttachmentProgressBar = _interopRequireDefault(require("../HBFileAttachment/HBFileAttachmentProgressBar"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _HBMediaElement = require("../HBMediaElement/HBMediaElement");
var _HBIconButton2 = require("../HBIconButton/HBIconButton.styles");
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _animations = require("../../styles/animations");
var _image = require("../common/image.utils");
var _HBFilePreview = _interopRequireDefault(require("../HBFilePreview/HBFilePreview"));
var _withStopPropagation = _interopRequireDefault(require("../common/withStopPropagation"));
var _HBLinkButton = _interopRequireDefault(require("../HBLinkButton/HBLinkButton"));
var _templateObject, _templateObject2;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ATTACHMENT_THUMBNAIL_SIZE = 58;
var ATTACHMENT_WIDTH = 184;
var isPdfExtension = function isPdfExtension(extension) {
  if (!extension) {
    return;
  }
  var regex = new RegExp('pdf', 'i');
  return regex.test(extension);
};
var getAttachmentThumbnail = function getAttachmentThumbnail(_ref) {
  var isPdf = _ref.isPdf,
    url = _ref.url;
  if (isPdf) {
    return (0, _image.generatePdfThumbnailUrl)({
      url: url,
      width: ATTACHMENT_THUMBNAIL_SIZE,
      height: ATTACHMENT_THUMBNAIL_SIZE
    });
  }
  var transformations = [{
    quality: 'auto',
    fetchFormat: 'auto',
    flags: 'lossy',
    crop: 'thumb',
    width: ATTACHMENT_THUMBNAIL_SIZE,
    height: ATTACHMENT_THUMBNAIL_SIZE,
    dpr: 3
  }];
  return (0, _HBMediaElement.addDefaultFlagsToCloudinaryUrl)(url, transformations) || url;
};
var HBFileAttachment = function HBFileAttachment(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
    className = _ref2.className,
    fileName = _ref2.fileName,
    fileType = _ref2.fileType,
    fileUrl = _ref2.fileUrl,
    _ref2$hideRemoveButto = _ref2.hideRemoveButton,
    hideRemoveButton = _ref2$hideRemoveButto === void 0 ? false : _ref2$hideRemoveButto,
    id = _ref2.id,
    testIdName = _ref2.testIdName,
    testId = _ref2.testId,
    onRemove = _ref2.onRemove,
    uploadProgress = _ref2.uploadProgress,
    uploadError = _ref2.uploadError,
    onRetry = _ref2.onRetry,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    onClick = _ref2.onClick,
    _ref2$canDownload = _ref2.canDownload,
    canDownload = _ref2$canDownload === void 0 ? true : _ref2$canDownload,
    _ref2$canPreview = _ref2.canPreview,
    canPreview = _ref2$canPreview === void 0 ? true : _ref2$canPreview,
    _ref2$withBoxShadow = _ref2.withBoxShadow,
    withBoxShadow = _ref2$withBoxShadow === void 0 ? true : _ref2$withBoxShadow,
    _ref2$shouldShowFileP = _ref2.shouldShowFilePreviewThumbnail,
    shouldShowFilePreviewThumbnail = _ref2$shouldShowFileP === void 0 ? true : _ref2$shouldShowFileP;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isPreviewShown = _useState2[0],
    setIsPreviewShown = _useState2[1];
  var fileRegex = fileName === null || fileName === void 0 ? void 0 : fileName.match(/\.([0-9a-zA-Z]+)(?:[\\?#]|$)/);
  var fileExtension = fileRegex === null || fileRegex === void 0 ? void 0 : fileRegex[1];
  var isRemovable = !hideRemoveButton && (!uploadProgress || uploadProgress === 100);
  var isFile = fileType === 'file';
  var isPdf = isPdfExtension(fileExtension);
  var imageThumbnail = uploadProgress ? null : getAttachmentThumbnail({
    url: fileUrl,
    isPdf: isPdf
  });
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'attachment',
    componentName: 'HBFileAttachment'
  });
  var handleClick = function handleClick() {
    onClick === null || onClick === void 0 || onClick({
      isFile: isFile
    });
    setIsPreviewShown(true);
  };
  var handleDownload = function handleDownload() {
    window.location.href = fileType === 'file' ? fileUrl : (0, _image.generateImageDownloadUrl)(fileUrl);
  };
  var isDownloadIconShown = !uploadProgress && !uploadError && canDownload;
  var shouldShowAction = isDownloadIconShown && !disabled;
  var onClickRemove = function onClickRemove(e) {
    e.stopPropagation();
    onRemove(id);
  };
  var shouldShowFileExtension = !shouldShowFilePreviewThumbnail || isFile && !isPdf || !fileUrl;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(InputContainer, {
    id: id,
    isDisabled: disabled,
    className: className,
    testId: finalTestId,
    onClick: disabled ? function () {} : handleClick,
    $backgroundColor: backgroundColor,
    $uploadError: uploadError,
    $withBoxShadow: withBoxShadow
  }, /*#__PURE__*/_react["default"].createElement(Content, {
    isDimmed: uploadProgress < 100
  }, /*#__PURE__*/_react["default"].createElement(PreviewContainer, null, shouldShowAction && /*#__PURE__*/_react["default"].createElement(QuickActionOverlay, null, /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], {
    buttonTheme: "light-invisible",
    icon: _Download["default"],
    testIdName: "download",
    onClick: (0, _withStopPropagation["default"])(handleDownload),
    label: "download"
  })), shouldShowFileExtension ? /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "subtitle14",
    color: "textSecondary"
  }, fileExtension || 'FILE') : /*#__PURE__*/_react["default"].createElement(Image, {
    onClick: isFile || disabled ? undefined : handleClick,
    url: imageThumbnail,
    testIdName: "image-preview",
    isDisabled: disabled
  })), fileName && /*#__PURE__*/_react["default"].createElement(Details, {
    title: fileName,
    noRemove: isRemovable
  }, /*#__PURE__*/_react["default"].createElement(FileTitle, null, fileName), !!uploadError && !!onRetry && /*#__PURE__*/_react["default"].createElement(RetryWrapper, null, /*#__PURE__*/_react["default"].createElement(Retry, {
    onClick: onRetry,
    testIdName: "retry",
    size: "sm"
  }, "Retry")))), isRemovable && /*#__PURE__*/_react["default"].createElement(RemoveAttachment, {
    icon: _Close["default"],
    label: "Remove attachment ".concat(fileName),
    onClick: onClickRemove,
    size: "xs",
    testId: finalTestId ? "".concat(finalTestId, "-remove") : undefined
  }), uploadProgress < 100 && /*#__PURE__*/_react["default"].createElement(ProgressBarContainer, null, /*#__PURE__*/_react["default"].createElement(_HBFileAttachmentProgressBar["default"], {
    percent: uploadProgress
  }))), !!uploadError && /*#__PURE__*/_react["default"].createElement(InvalidWrapper, null, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    color: "red50",
    type: "caption12"
  }, uploadError))), isPreviewShown && canPreview && /*#__PURE__*/_react["default"].createElement(_HBFilePreview["default"], {
    fileName: fileName,
    fileUrl: fileUrl,
    fileType: fileType,
    onClose: function onClose() {
      return setIsPreviewShown(false);
    },
    onDownload: canDownload ? handleDownload : null
  }));
};
var _default = exports["default"] = HBFileAttachment; // -------------------------------- Styles -------------------------------- //
var QuickActionOverlay = _styledComponents["default"].div.withConfig({
  displayName: "HBFileAttachment__QuickActionOverlay",
  componentId: "sc-gnerxr-0"
})(["background-color:", ";", ";opacity:0;position:absolute;width:inherit;height:inherit;display:flex;align-items:center;justify-content:center;"], _colors["default"].black_07, (0, _animations.transition)('opacity'));
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBFileAttachment__Container",
  componentId: "sc-gnerxr-1"
})(["display:flex;flex-direction:column;"]);
var InputContainer = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBFileAttachment__InputContainer",
  componentId: "sc-gnerxr-2"
})(["width:", "px;display:flex;gap:4px;font-family:ProximaNova,Arial,sans-serif;border-radius:4px;border:solid 1px ", ";position:relative;overflow:hidden;", ";background-color:", ";@media (hover){&:hover{", "{opacity:1;}", ";}}"], ATTACHMENT_WIDTH, function (_ref3) {
  var $uploadError = _ref3.$uploadError;
  return $uploadError ? _colors["default"].red50 : _colors["default"].neutral200;
}, (0, _animations.transition)('box-shadow'), function (props) {
  return props.$backgroundColor || 'transparent';
}, QuickActionOverlay, function (_ref4) {
  var $withBoxShadow = _ref4.$withBoxShadow;
  return $withBoxShadow && (0, _styledComponents.css)(["box-shadow:0 10px 20px 0 ", ";"], _colors["default"].blue_015);
});
var Content = _styledComponents["default"].div.withConfig({
  displayName: "HBFileAttachment__Content",
  componentId: "sc-gnerxr-3"
})(["display:flex;flex:1;flex-direction:row;justify-content:space-between;align-items:stretch;transition:opacity 0.2s linear;", ""], (0, _styledIs["default"])('isDimmed')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        opacity: 0.4;\n    "]))));
var InvalidWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBFileAttachment__InvalidWrapper",
  componentId: "sc-gnerxr-4"
})(["padding-block-start:4px;display:flex;"]);
var RetryWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBFileAttachment__RetryWrapper",
  componentId: "sc-gnerxr-5"
})(["flex:1;display:flex;justify-content:flex-end;"]);
var Retry = (0, _styledComponents["default"])(_HBLinkButton["default"]).withConfig({
  displayName: "HBFileAttachment__Retry",
  componentId: "sc-gnerxr-6"
})(["align-self:flex-end;margin-left:6px;cursor:pointer;"]);
var RemoveAttachment = (0, _styledComponents["default"])(_HBIconButton["default"]).withConfig({
  displayName: "HBFileAttachment__RemoveAttachment",
  componentId: "sc-gnerxr-7"
})(["position:absolute;top:0;right:0;height:40px;", "{&:hover{background:transparent;}cursor:pointer;}"], _HBIconButton2.IconButton);
var ProgressBarContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBFileAttachment__ProgressBarContainer",
  componentId: "sc-gnerxr-8"
})(["position:absolute;bottom:0;width:100%;"]);
var PreviewContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBFileAttachment__PreviewContainer",
  componentId: "sc-gnerxr-9"
})(["width:58px;height:58px;background:", ";display:flex;justify-content:center;align-items:center;"], _colors["default"].neutral200);
var Image = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBFileAttachment__Image",
  componentId: "sc-gnerxr-10"
})(["background-image:url(", ");border-radius:4px 0 0 4px;background-size:cover;background-repeat:no-repeat;width:100%;height:100%;"], function (props) {
  return props.url;
});
var FileTitle = _styledComponents["default"].div.withConfig({
  displayName: "HBFileAttachment__FileTitle",
  componentId: "sc-gnerxr-11"
})(["width:100%;overflow:hidden;text-overflow:ellipsis;font-size:12px;font-weight:600;"]);
var Details = _styledComponents["default"].div.withConfig({
  displayName: "HBFileAttachment__Details",
  componentId: "sc-gnerxr-12"
})(["padding:8px 8px 0;width:88px;", ";white-space:nowrap;flex-grow:1;display:flex;flex-direction:column;"], (0, _styledIs.isNot)('noRemove')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        padding-right:8px;\n        width: 110px;\n    "]))));
//# sourceMappingURL=HBFileAttachment.js.map